import React from 'react'

const MissingClaimDetails = () => {
  return (
      <div class="col-md-6 col-12 mb-2 pb-1">

          <div class="card mb-0 border-0">
              <a class="card-header sh_accordionheader" data-bs-toggle="collapse" href="#missingClaimsDetails" role="button" aria-expanded="true" aria-controls="missingClaimsDetails">Missing Claims Details</a>
              <div class="collapse show" id="missingClaimsDetails">
                  <div class="card-body px-0 py-2">
                      <div class="row">
                          <div class="col-md-6 col-6">
                              <div class="d-flex sh_statusIndicatorbox medium-pink px-3 py-2">
                                  <div class="d-flex align-items-center ">
                                      <span class="sh_statusIndicator ">
                                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M6 4H18" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
                                              <path d="M6 20H18" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
                                              <path d="M8 4V8C8 8.63 8.296 9.222 8.8 9.6L12 12L15.2 9.6C15.704 9.222 16 8.63 16 8V4" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
                                              <path d="M16 20V16C16 15.37 15.704 14.778 15.2 14.4L12 12L8.8 14.4C8.296 14.778 8 15.37 8 16V20" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
                                          </svg>

                                      </span>
                                  </div>
                                  <div class="d-flex flex-column">
                                      <p class="p1-light text-dark mb-0">Total Pending Claims</p>
                                      <h3 class="h3-strong mb-0 ">12</h3>
                                  </div>
                              </div>
                          </div>
                          <div class="col-md-6 col-6">
                              <div class="d-flex sh_statusIndicatorbox cyan px-3 py-2">
                                  <div class="d-flex align-items-center ">
                                      <span class="sh_statusIndicator ">
                                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M20.9332 13.4326C20.1714 17.9519 16.1349 21.1767 11.5589 20.9217C6.98296 20.6668 3.32963 17.0134 3.07467 12.4375C2.8197 7.86155 6.04456 3.82497 10.5639 3.06323" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
                                              <path d="M20.4984 8.79785C20.6956 9.32766 20.842 9.87502 20.9356 10.4325" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
                                              <path d="M19.0042 6.19462C18.6433 5.75767 18.2416 5.35603 17.8047 4.99512" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
                                              <path d="M15.2011 3.50153C14.6713 3.30387 14.124 3.15715 13.5664 3.06334" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
                                              <path d="M16.0022 12.3913H11.6094V6.99805" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
                                          </svg>

                                      </span>
                                  </div>
                                  <div class="d-flex flex-column">
                                      <p class="p1-light text-dark mb-0">Average Processing Time</p>
                                      <div class="d-inline-flex align-items-center gap-1"><h3 class="h3-strong mb-0 ">14</h3><span class="p2-light text-dark px-1">Days</span></div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card-body sh_dashtableoverflowcard px-0 pt-0 mt-2 pb-2">
                      <table class="table dataTable sh_tablenew">
                          <thead>
                              <tr>
                                  <th>Employee </th>
                                  <th>Type</th>
                                  <th>Claim Id</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td>Jhon Smith</td>
                                  <td>Physicals</td>
                                  <td>92007</td>
                              </tr>
                              <tr>
                                  <td>Emily Jhonson</td>
                                  <td>Drug screen</td>
                                  <td>92008</td>
                              </tr>
                              <tr>
                                  <td>Jhon Smith</td>
                                  <td>Physicals</td>
                                  <td>92009</td>
                              </tr>
                              <tr>
                                  <td>Emily Jhonson</td>
                                  <td>Drug screen</td>
                                  <td>92010</td>
                              </tr>
                              <tr>
                                  <td>Jhon Smith</td>
                                  <td>Physicals</td>
                                  <td>92011</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
      </div>
  )
}

export default MissingClaimDetails